import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import { Provider } from "react-redux";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import "react-circular-progressbar/dist/styles.css";
import "react-calendar-timeline/lib/Timeline.css";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import store from "./redux/store";

ReactDOM.render(
  <React.Fragment>
    <Provider store={store}>
    <App />
   </Provider>
  </React.Fragment>,
  document.getElementById("root"),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
